<form [formGroup]="form" (submit)="onSubmit()">
  <pai-newsletter-subscription-form [form]="form" [appearance]="data().inputAppearance ?? 'outline'" />

  <p class="hint">{{ 'NewsletterSubscriptionForm.Hint' | translate }}</p>

  <button class="button" pai-button type="submit" [disabled]="form.invalid" [isLoading]="submitAction.isPending()">
    <span>{{ 'NewsletterSubscriptionForm.Action.Submit' | translate }}</span>
  </button>

  @if (submitAction.hasError()) {
    <p class="message message--error">{{ 'NewsletterSubscriptionForm.ErrorMessage' | translate }}</p>
  } @else if (submitAction.hasResult()) {
    <p class="message message--success">{{ 'NewsletterSubscriptionForm.SuccessMessage' | translate }}</p>
  }
</form>
